import type {
	FrontendPlacementMessage,
	AnyFrontendStage,
} from '@post-office/message-maker-browser/types';
import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';
import { PlacementFrontend } from '@post-office/browser--jira-chronos/jira-plans-release-date';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { ReleaseDateSpotlight } from './message';

export const MessageFrontend: (
	config: CreatePlacementMessageConfig,
) => FrontendPlacementMessage<{ render: AnyFrontendStage }> =
	PlacementFrontend.createMessageFrontend({
		render: {
			validate: assertMessageTemplateContext,
			Component: ReleaseDateSpotlight,
		},
	});
